import { render, staticRenderFns } from "./_orders-table.component.vue?vue&type=template&id=96628a10&scoped=true"
import script from "./_orders-table.component.vue?vue&type=script&lang=js"
export * from "./_orders-table.component.vue?vue&type=script&lang=js"
import style0 from "./_orders-table.component.vue?vue&type=style&index=0&id=96628a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96628a10",
  null
  
)

export default component.exports